import './picker.scss';
import { attachPropertiesToComponent } from "../../utils/attach-properties-to-component";
import { CnPicker as Picker } from './picker';
import { prompt } from './prompt';
export var CnPicker = attachPropertiesToComponent(Picker, {
    prompt: prompt,
});
